// HubSpot Forms Submission API v3 — mirrors the legacy WordPress
// `signup-code.js` integration. After a successful account registration the WP
// page fires a fire-and-forget POST to HubSpot with the new user's email/name.
// A failure here must never block or surface in the signup flow.
//
// Public, no-auth form-submit endpoint (safe to call from the browser).
const HUBSPOT_PORTAL_ID = '5847375'
const HUBSPOT_SIGNUP_FORM_GUID = '75db54bb-b348-42ff-85e9-0bffbb79620a'

// HubSpot's visitor-tracking cookie, used for analytics attribution when the
// HubSpot tracking script is present. Absent otherwise (harmless).
function getHubspotUtk() {
	const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/)
	return match ? decodeURIComponent(match[1]) : ''
}

// Submits a new signup to HubSpot. Fire-and-forget: callers should NOT await
// this in a way that blocks the signup flow, and it never throws.
export async function submitSignupToHubspot({ email, name, phone } = {}) {
	if (!email) return

	const url = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_SIGNUP_FORM_GUID}`

	const fields = [
		{ name: 'email', value: email },
		{ name: 'firstname', value: name || '' },
		{ name: 'phone_verification', value: true },
	]
	// The HubSpot form must expose a field whose internal name is `phone`, or it
	// rejects the ENTIRE submission (not just the unknown field). Needs live
	// verification against the portal; fire-and-forget means a rejection only
	// logs a warning below.
	if (typeof phone === 'string' && phone.trim()) {
		fields.push({ name: 'phone', value: phone })
	}

	const body = {
		submittedAt: Date.now(),
		fields,
		legalConsentOptions: {
			consent: {
				consentToProcess: true,
				text: 'I agree to allow Castr Company to store and process my personal data.',
				communications: [
					{
						value: true,
						// NOTE: 999 is carried over verbatim from the WP code as a
						// placeholder. Confirm the real subscription type ID in the
						// HubSpot portal and update it here.
						subscriptionTypeId: 999,
						text: 'I agree to receive marketing communications from Castr Company.',
					},
				],
			},
		},
	}

	// Attribution context (not in WP): links the submission to the visitor's
	// HubSpot analytics session when the tracking cookie exists.
	const hutk = getHubspotUtk()
	if (hutk) {
		body.context = {
			hutk,
			pageUri: window.location.href,
			pageName: document.title,
		}
	}

	try {
		await fetch(url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body),
		})
	} catch (e) {
		// Fire-and-forget: log only, never block signup.
		console.warn('[hubspot] signup submission failed', e)
	}
}
